import {resources, scopes} from '../../permissions/dictionary';
import {paths} from '../../dictionaries/urls';
import {filterByPermissions} from './helpers';


const waitHappyOut = [
  {
    'name': 'Listado de vehiculos',
    'path': paths.ListVehiclesWaitHappy,
    'resource': resources.ListVehiclesWaitHappy,
    'scopes': [scopes.See],
    'icon': 'partsSearch',
  },
];


const getWaitHappyOutcomeOptions = (permissions) => {
  const options = [{
    'name': 'Proceso',
    'options': filterByPermissions(permissions, waitHappyOut),
  }];

  return options.filter((item) => item.options.length);
};

export const getWaitHappyOptions = (permissions) => {
  const options = [
    {
      'name': 'Espera feliz',
      'options': getWaitHappyOutcomeOptions(permissions),
    }];
  
  return options.filter((item) => item.options.length);
};


export const happyWaitOptions = [
  ...waitHappyOut,
];
